import { PACK_LOT_HOLD_LABEL, PACK_LOT_STATUS_LABEL } from '../../model/lab/labText'
import { Status } from '../bits'

/** A pack lot's one status plus its separate hold (R02). */
export function PackLotState({ status, hold, short }: { status: string; hold: string; short?: boolean }) {
  return (
    <span className="flex flex-wrap items-center gap-1">
      <Status status={status === 'CLOSED' ? 'WAITING' : status} label={short && status === 'CLOSED' ? 'Closed' : PACK_LOT_STATUS_LABEL[status]} />
      {hold !== 'NONE' && <Status status={hold} label={PACK_LOT_HOLD_LABEL[hold]} />}
    </span>
  )
}
